import { gql } from '@urql/core';
import React from 'react';
import { MyUpcomingEventsFragment } from '../../../generated/spin-graphql';
import { EventCard } from '../../events/card/EventCard';

type Props = {
    events: MyUpcomingEventsFragment[];
};

gql`
    fragment MyUpcomingEvents on espin_event {
        ...EventCard
        event_registrations {
            id
        }
    }
`;

export const MyUpcomingEvents: React.FC<Props> = ({ events }) => {
    return (
        <div className="my-upcoming-events-card">
            <div className="title-container">
                <h2 className="title">Upcoming Events</h2>
            </div>
            <div className="content">
                {events.map((event, index: number) => (
                    <EventCard key={`upcoming-event-card-${index}`} event={event} />
                ))}
            </div>
        </div>
    );
};
